import { c as _c } from "react/compiler-runtime";
import { IconButton } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import { useT } from '@repo/i18n/components/i18n.client';
import { css } from '@repo/panda/css';
import { useAppSelector } from '@repo/store/maps/hooks';
import { selectIsBulkMovingLocations, selectIsInCreatorMode } from '@repo/store/maps/slices/mapData';
import { useAuth } from '@repo/ui-web/auth/auth-hooks';
import { useCreatorToolOperations } from '../game-map/hooks/useCreatorToolOperations';
export const AddMapLocation = () => {
  const $ = _c(20);
  const {
    isAuthenticated
  } = useAuth();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = ["game_map"];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useT(t0);
  const {
    isAddingMapLocation,
    startAddingMapLocation,
    cancelAddingMapLocation
  } = useCreatorToolOperations();
  const isInCreatorMode = useAppSelector(selectIsInCreatorMode);
  const isBulkMovingLocations = useAppSelector(selectIsBulkMovingLocations);
  let t1;
  if ($[1] !== cancelAddingMapLocation || $[2] !== isAddingMapLocation || $[3] !== isBulkMovingLocations || $[4] !== startAddingMapLocation) {
    t1 = () => {
      if (isBulkMovingLocations) {
        return;
      }
      if (isAddingMapLocation) {
        cancelAddingMapLocation();
      } else {
        startAddingMapLocation();
      }
    };
    $[1] = cancelAddingMapLocation;
    $[2] = isAddingMapLocation;
    $[3] = isBulkMovingLocations;
    $[4] = startAddingMapLocation;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const handleAddLocation = t1;
  if (!isInCreatorMode) {
    return null;
  }
  const t2 = isAddingMapLocation ? "black" : "white";
  const t3 = !isAuthenticated || isBulkMovingLocations;
  let t4;
  if ($[6] !== isAddingMapLocation || $[7] !== t) {
    t4 = isAddingMapLocation ? t(_temp) : t(_temp2);
    $[6] = isAddingMapLocation;
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const t5 = isAddingMapLocation ? "purple.600" : "white";
  let t6;
  if ($[9] !== t5) {
    t6 = css({
      background: t5,
      borderRadius: "full",
      "&:not(:focus-visible)": {
        boxShadow: "lg"
      }
    });
    $[9] = t5;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const t7 = isAddingMapLocation ? "close" : "add_location_alt";
  let t8;
  if ($[11] !== t7) {
    t8 = <Icon icon={t7} decorative={true} />;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== handleAddLocation || $[14] !== t2 || $[15] !== t3 || $[16] !== t4 || $[17] !== t6 || $[18] !== t8) {
    t9 = <IconButton onClick={handleAddLocation} color={t2} size="lg" disabled={t3} aria-label={t4} className={t6}>{t8}</IconButton>;
    $[13] = handleAddLocation;
    $[14] = t2;
    $[15] = t3;
    $[16] = t4;
    $[17] = t6;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
};
function _temp($) {
  return $.add_location_instructions;
}
function _temp2($_0) {
  return $_0.add_map_location;
}